'use client';

import { Slider, styled } from '@mui/material';
import { CSSProperties } from 'react';

import { Theme } from '../../theme';

import { SliderVariant } from './types';

const getColorByVariant = (theme: Theme, variant: SliderVariant) => {
  if (variant === 'primary') {
    return theme.palette.primary.main;
  }

  return theme.palette.success.main;
};

export const SliderContainer = styled('div')(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3, 4, 5, 4),
}));

export const StyledSlider = styled(Slider, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{
  variant: SliderVariant;
}>(({ theme, variant }) => ({
  margin: 0,
  padding: '0 !important',

  '.MuiSlider-rail': {
    color: theme.palette.divider,
  },

  '.MuiSlider-track': {
    opacity: 1,
    color: getColorByVariant(theme, variant),
  },

  '.MuiSlider-thumb': {
    maxWidth: 16,
    maxHeight: 16,
    color: getColorByVariant(theme, variant),
    border: `1px solid ${theme.palette.surface1}`,
  },

  '.MuiSlider-mark': {
    width: 3,
    height: 3,
    borderRadius: '50%',
    backgroundColor: theme.palette.black[500],
  },

  '.MuiSlider-markActive': {
    width: 3,
    height: 3,
    borderRadius: '50%',
    backgroundColor: theme.palette.black[50],
  },

  '.MuiSlider-markLabel': {
    top: theme.spacing(3),
    ...(theme.typography.body8 as CSSProperties),
    color: theme.palette.text3,
  },

  '.MuiSlider-valueLabel': {
    backgroundColor: theme.palette.surface4,
  },
}));
